import { apiFetch } from "./http";

export interface TicketFile {
  id: number;
  filename: string;
  content_type: string;
  object_key: string;
  uploaded_at: string;
  uploaded_by: string | null;
  url?: string | null;
}

export async function listTicketFiles(ticketId: number, signal?: AbortSignal): Promise<TicketFile[]> {
  return apiFetch<TicketFile[]>(`/tickets/${ticketId}/files`, { signal });
}

export async function uploadTicketFile(ticketId: number, file: File, uploadedBy?: string): Promise<TicketFile> {
  const form = new FormData();
  form.append("file", file);
  if (uploadedBy) {
    form.append("uploaded_by", uploadedBy);
  }

  return apiFetch<TicketFile>(`/tickets/${ticketId}/files`, {
    method: "POST",
    body: form,
  });
}

export async function deleteTicketFile(ticketId: number, fileId: number): Promise<void> {
  await apiFetch<void>(`/tickets/${ticketId}/files/${fileId}`, { method: "DELETE", skipJsonParse: true });
}
